/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPing = getPing;
exports.resetPing = resetPing;
exports.getClientConfig = getClientConfig;
exports.getLicenseConfig = getLicenseConfig;
exports.logClientError = logClientError;
exports.setAppState = setAppState;
exports.setDeviceToken = setDeviceToken;
exports.setServerVersion = setServerVersion;
exports.setStoreFromLocalData = setStoreFromLocalData;
exports.setUrl = setUrl;

var _client = require('../client');

var _helpers = require('./helpers.js');

var _action_types = require('../action_types');

var _constants = require('../constants');

var _users = require('./users');

var _event_emitter = require('../utils/event_emitter');

var _event_emitter2 = _interopRequireDefault(_event_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getPing() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data, pingError;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.PING_REQUEST }, getState);

                            data = void 0;
                            pingError = new _helpers.FormattedError('mobile.server_ping_failed', 'Cannot connect to the server. Please check your server URL and internet connection.');
                            _context.prev = 3;
                            _context.next = 6;
                            return _client.Client4.ping();

                        case 6:
                            data = _context.sent;

                            if (data.status) {
                                _context.next = 10;
                                break;
                            }

                            // successful ping but not the right return data
                            dispatch({ type: _action_types.GeneralTypes.PING_FAILURE, error: pingError }, getState);
                            return _context.abrupt('return');

                        case 10:
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            dispatch({ type: _action_types.GeneralTypes.PING_FAILURE, error: pingError }, getState);
                            return _context.abrupt('return');

                        case 16:

                            dispatch({ type: _action_types.GeneralTypes.PING_SUCCESS, data: data }, getState);

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 12]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function resetPing() {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.PING_RESET }, getState);

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getClientConfig() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getClientConfigOld, _action_types.GeneralTypes.CLIENT_CONFIG_REQUEST, [_action_types.GeneralTypes.CLIENT_CONFIG_RECEIVED, _action_types.GeneralTypes.CLIENT_CONFIG_SUCCESS], _action_types.GeneralTypes.CLIENT_CONFIG_FAILURE);
}

function getLicenseConfig() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getClientLicenseOld, _action_types.GeneralTypes.CLIENT_LICENSE_REQUEST, [_action_types.GeneralTypes.CLIENT_LICENSE_RECEIVED, _action_types.GeneralTypes.CLIENT_LICENSE_SUCCESS], _action_types.GeneralTypes.CLIENT_LICENSE_FAILURE);
}

function logClientError(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ERROR';

    return (0, _helpers.bindClientFunc)(_client.Client4.logClientError, _action_types.GeneralTypes.LOG_CLIENT_ERROR_REQUEST, _action_types.GeneralTypes.LOG_CLIENT_ERROR_SUCCESS, _action_types.GeneralTypes.LOG_CLIENT_ERROR_FAILURE, message, level);
}

function setAppState(state) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_APP_STATE, data: state }, getState);

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function setDeviceToken(token) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_APP_DEVICE_TOKEN, data: token }, getState);

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x8, _x9) {
            return _ref4.apply(this, arguments);
        };
    }();
}

_event_emitter2.default.on(_constants.General.CONFIG_CHANGED, setServerVersion);

function setServerVersion(serverVersion) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_SERVER_VERSION, data: serverVersion }, getState);

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }));

        return function (_x10, _x11) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function setStoreFromLocalData(data) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _client.Client.setToken(data.token);
                            _client.Client.setUrl(data.url);
                            _client.Client4.setToken(data.token);
                            _client.Client4.setUrl(data.url);

                            return _context6.abrupt('return', (0, _users.loadMe)()(dispatch, getState));

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }));

        return function (_x12, _x13) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function setUrl(url) {
    _client.Client.setUrl(url);
    _client.Client4.setUrl(url);
    return true;
}

exports.default = {
    getPing: getPing,
    getClientConfig: getClientConfig,
    getLicenseConfig: getLicenseConfig,
    logClientError: logClientError,
    setAppState: setAppState,
    setDeviceToken: setDeviceToken,
    setServerVersion: setServerVersion,
    setStoreFromLocalData: setStoreFromLocalData,
    setUrl: setUrl
};



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/actions/general.js
// module id = 189
// module chunks = 60